import { ReactNode } from 'react'
import clsx from 'clsx'

import { Modal } from '@makyoapp/makyo-ui'

interface IGridModalWrap {
  children: ReactNode
  title: ReactNode
  handleCloseMenu?: () => void
}

export function GridModalWrap({ children, title, handleCloseMenu }: IGridModalWrap) {
  return (
    <div className={clsx('w-[360px] md:w-[580px] lg:w-[650px] lg:min-w-[650px] mk-bg text-m-m')}>
      <Modal.Header onCloseClick={handleCloseMenu}>{title}</Modal.Header>
      {children}
    </div>
  )
}
